let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iWJzm")).then(() => parcelRequire('7DSXR'));